// Permission key groups — each key maps to a UI action
export const PERMISSION_GROUPS = [
  {
    group: "Dashboard",
    permissions: [{ key: "dashboard.view", label: "View Dashboard" }],
  },
  {
    group: "Products",
    permissions: [
      { key: "products.view",   label: "View"   },
      { key: "products.create", label: "Create" },
      { key: "products.edit",   label: "Edit"   },
      { key: "products.delete", label: "Delete" },
    ],
  },
  {
    group: "Categories",
    permissions: [
      { key: "categories.view",   label: "View"   },
      { key: "categories.create", label: "Create" },
      { key: "categories.edit",   label: "Edit"   },
      { key: "categories.delete", label: "Delete" },
    ],
  },
  {
    group: "Orders",
    permissions: [
      { key: "orders.view", label: "View"          },
      { key: "orders.edit", label: "Update Status" },
    ],
  },
  {
    group: "Customers",
    permissions: [
      { key: "customers.view",   label: "View"   },
      { key: "customers.create", label: "Create" },
      { key: "customers.edit",   label: "Edit"   },
      { key: "customers.delete", label: "Delete" },
    ],
  },
  {
    group: "Blog",
    permissions: [
      { key: "blog.view",   label: "View"   },
      { key: "blog.create", label: "Create" },
      { key: "blog.edit",   label: "Edit"   },
      { key: "blog.delete", label: "Delete" },
    ],
  },
  {
    group: "Pages",
    permissions: [
      { key: "pages.view",   label: "View"   },
      { key: "pages.create", label: "Create" },
      { key: "pages.edit",   label: "Edit"   },
      { key: "pages.delete", label: "Delete" },
    ],
  },
  {
    group: "User Roles",
    permissions: [
      { key: "roles.view",   label: "View"   },
      { key: "roles.create", label: "Create" },
      { key: "roles.edit",   label: "Edit"   },
      { key: "roles.delete", label: "Delete" },
    ],
  },
  {
    group: "Settings",
    permissions: [
      { key: "settings.view", label: "View" },
      { key: "settings.edit", label: "Edit" },
    ],
  },
];

// All permission keys with every flag set to true (for the Admin role preset)
export const ALL_PERMISSIONS = PERMISSION_GROUPS.reduce((acc, group) => {
  group.permissions.forEach((p) => { acc[p.key] = true; });
  return acc;
}, {});

// Empty permission set (all false)
export const NO_PERMISSIONS = PERMISSION_GROUPS.reduce((acc, group) => {
  group.permissions.forEach((p) => { acc[p.key] = false; });
  return acc;
}, {});
